import { atom } from 'jotai';

// Counter atom for state management
export const countAtom = atom(0);

// Message atom for displaying text
export const messageAtom = atom('Hello from Jotai!');
